import React, { useState } from 'react';
import ReactMapGL, { Marker }  from 'react-map-gl';
import { mapBoxKey } from '../../ApiKey.js';
import './AboutScreen.css';

import Nav from '../../Components/Nav/Nav';
import Footer from '../../Components/Footer/Footer';

function AboutScreen() {

    const [viewport, setViewport] = useState({
        latitude: 37.7000,
        longitude: -122.4376,
        zoom: 9,
        pitch: 50
    });

    
    return (
        <>
            <Nav transparent={true} />
            <div className='about__screen'>
                <div className='about__screen__container'>
                    <div className="head__img" style={{backgroundImage: 'url(https://welshdesignstudio.com/wp-content/uploads/woman-at-furniture-store-s.jpeg)', height: '400px', width: '100%', backgroundSize: 'cover', backgroundPosition: 'center center'}}>
                        <div className='image__shader'></div>
                    </div>
                    <div className="about__room__section">
                        <h1>About Room</h1>
                        <br />
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio culpa deserunt modi ipsam, eius voluptates alias dolorum consequatur veniam enim labore eligendi vitae! Ut doloribus architecto exercitationem corporis ipsam dolore.</p>
                    </div>
                    <div className='about__trading__section'>
                        <h1>About Room Trading</h1>
                        <br />
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum non impedit provident corporis nesciunt sit sint, alias eius consequatur cupiditate. Ab exercitationem autem harum aut vel, incidunt officia ducimus nesciunt.</p>
                        <br />
                        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Corporis suscipit veniam vitae quia ipsam blanditiis, nulla neque facere facilis at nisi asperiores commodi, qui necessitatibus tempore aspernatur quae officia. Minima?</p>
                    </div>
                    <div className="about__faq">
                        <h1>FAQs'</h1>
                        <br />
                        <div className='question__div'>
                            <div className='question'>
                                <p>question</p>
                            </div>
                            <br />
                            <div className='answer'>
                                <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Illum dicta fugit reiciendis fugiat officiis est amet, cumque sit mollitia fuga cupiditate debitis obcaecati deleniti tenetur dolorum hic, distinctio dolores qui!</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="about__location">
                        <div className="about__content">
                            <h1>Where To Find Us</h1>
                            <br />
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tempore dicta rerum maxime, neque, temporibus blanditiis, facere error nulla magni odio voluptatibus. Soluta blanditiis iste velit aliquid amet veritatis illum provident?</p>
                            
                        </div>
                        <br />
                        <div className='map__div'>
                            <ReactMapGL
                                className='map__div__mapbox'
                                mapboxApiAccessToken={mapBoxKey}
                                {...viewport}
                                // mapStyle={'mapbox://styles/mapbox/dark-v9'}
                                width='100%'
                                height='100%'
                                onViewportChange={(viewport) => setViewport(viewport)}
                            >

                                <Marker className='map__marker' latitude={37.6} offsetTop={-50} longitude={-122.5}>
                                    <svg style={{fill: 'red'}} width="46" height="56"><path fillRule="evenodd" d="M39.263 7.673c8.897 8.812 8.966 23.168.153 32.065l-.153.153L23 56 6.737 39.89C-2.16 31.079-2.23 16.723 6.584 7.826l.153-.152c9.007-8.922 23.52-8.922 32.526 0zM23 14.435c-5.211 0-9.436 4.185-9.436 9.347S17.79 33.128 23 33.128s9.436-4.184 9.436-9.346S28.21 14.435 23 14.435z"/></svg>
                                </Marker>

                                <Marker className='map__marker' latitude={37.8} offsetTop={-50} longitude={-122.478}>
                                    <svg style={{fill: 'red'}} width="46" height="56"><path fillRule="evenodd" d="M39.263 7.673c8.897 8.812 8.966 23.168.153 32.065l-.153.153L23 56 6.737 39.89C-2.16 31.079-2.23 16.723 6.584 7.826l.153-.152c9.007-8.922 23.52-8.922 32.526 0zM23 14.435c-5.211 0-9.436 4.185-9.436 9.347S17.79 33.128 23 33.128s9.436-4.184 9.436-9.346S28.21 14.435 23 14.435z"/></svg>
                                </Marker>

                                <Marker className='map__marker' latitude={37.9} offsetTop={-50} longitude={-122.5}>
                                    <svg style={{fill: 'red'}} width="46" height="56"><path fillRule="evenodd" d="M39.263 7.673c8.897 8.812 8.966 23.168.153 32.065l-.153.153L23 56 6.737 39.89C-2.16 31.079-2.23 16.723 6.584 7.826l.153-.152c9.007-8.922 23.52-8.922 32.526 0zM23 14.435c-5.211 0-9.436 4.185-9.436 9.347S17.79 33.128 23 33.128s9.436-4.184 9.436-9.346S28.21 14.435 23 14.435z"/></svg>
                                </Marker>

                                <Marker className='map__marker' latitude={37.81} offsetTop={-50} longitude={-122.28}>
                                    <svg style={{fill: 'red'}} width="46" height="56"><path fillRule="evenodd" d="M39.263 7.673c8.897 8.812 8.966 23.168.153 32.065l-.153.153L23 56 6.737 39.89C-2.16 31.079-2.23 16.723 6.584 7.826l.153-.152c9.007-8.922 23.52-8.922 32.526 0zM23 14.435c-5.211 0-9.436 4.185-9.436 9.347S17.79 33.128 23 33.128s9.436-4.184 9.436-9.346S28.21 14.435 23 14.435z"/></svg>
                                </Marker>

                            </ReactMapGL>
                        </div>
                    </div>
            </div>
            <Footer />
        </>
    )
}

export default AboutScreen
